// shared/pdf/components/PdfHeader.jsx
import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const s = StyleSheet.create({
  band:       { paddingVertical: 14, paddingHorizontal: 40, alignItems: 'center' },
  orgName:    { fontSize: 18, fontFamily: 'NotoSans', fontWeight: 'bold', marginBottom: 3, letterSpacing: 0.3 },
  meta:       { fontSize: 8.5, fontFamily: 'NotoSans', marginTop: 2, textAlign: 'center' },
  titleStrip: { paddingVertical: 7, paddingHorizontal: 40, alignItems: 'center' },
  titleText:  { fontSize: 12, fontFamily: 'NotoSans', fontWeight: 'bold', letterSpacing: 0.8 },
  accent:     { height: 3 },
});

export default function PdfHeader({ derasar, reportTitle, theme }) {
  const name = derasar?.name || 'Derasar';

  // Address: admin profile address takes priority, then derasar's own address field
  const adminAddressLine = derasar?.adminAddressLine || '';
  const derasarAddress   = [derasar?.address, derasar?.city].filter(Boolean).join(', ');
  const address          = adminAddressLine || derasarAddress;

  // Contact: from derasars table
  const phone = derasar?.contactPhone || '';
  const email = derasar?.contactEmail || '';
  const contactLine = [
    phone ? `Ph: ${phone}` : '',
    email ? `Email: ${email}` : '',
  ].filter(Boolean).join('     |     ');

  return (
    <View fixed>
      <View style={[s.band, { backgroundColor: theme.primary }]}>
        <Text style={[s.orgName, { color: theme.headerText }]}>{name}</Text>
        {address      ? <Text style={[s.meta, { color: theme.headerText }]}>{address}</Text>      : null}
        {contactLine  ? <Text style={[s.meta, { color: theme.headerText }]}>{contactLine}</Text>  : null}
      </View>
      <View style={[s.titleStrip, { backgroundColor: theme.white }]}>
        <Text style={[s.titleText, { color: theme.titleText }]}>
          {(reportTitle || '').toUpperCase()}
        </Text>
      </View>
      <View style={[s.accent, { backgroundColor: theme.grad }]} />
    </View>
  );
}
